<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="DinnerName" label="名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>
        <el-table-column prop="StartTime" label="开始时间" width="">
        </el-table-column>
        <el-table-column prop="EndTime" label="结束时间" width="">
        </el-table-column>
        <el-table-column label="时间段消费模式" width="">
          <template slot-scope="scope">
            <div>
              <div>限次：{{ scope.row.LimitTimes || '-' }}</div>
              <div>每次就餐金额：{{ scope.row.FixedAmount || 0 }}元</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="请假可退餐" width="150" align="center">
          <template slot-scope="scope">
            <el-tag v-if="!scope.row.AllowLeaveMealRefund" size="mini" type="info">不可退</el-tag>
            <el-tag v-else size="mini" type="success">可退餐</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Remarks" label="备注" width="">
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间">
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑就餐时间信息" :visible.sync="editFormVisible" v-model="editFormVisible"
        width="600px" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="130px" :rules="editFormRules" ref="editForm">

          <el-form-item label="名称" prop="DinnerName">
            <el-input v-model="editForm.DinnerName" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="就餐时间" prop="TimeArr">
            <el-time-picker is-range value-format="HH:mm:ss" v-model="editForm.TimeArr" style="width: 280px"
              start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="限次" prop="LimitTimes">
            <el-input-number v-model="editForm.LimitTimes" :min="1" :max="99" />
          </el-form-item>

          <el-form-item label="每次就餐金额(元)" prop="FixedAmount">
            <el-input v-model="editForm.FixedAmount" type="number" min="0" />
          </el-form-item>

          <el-form-item label="请假可退餐">
            <el-switch v-model="editForm.AllowLeaveMealRefund" active-text="是" inactive-text="否"></el-switch>
            <div class="field-desc">开启后请假时可勾选本餐退餐，仅做登记，不联动订餐退订</div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增就餐时间信息" :visible.sync="addFormVisible" v-model="addFormVisible" width="600px" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="130px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="名称" prop="DinnerName">
            <el-input v-model="addForm.DinnerName" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="就餐时间" prop="TimeArr">
            <el-time-picker is-range value-format="HH:mm:ss" v-model="addForm.TimeArr" style="width: 280px"
              start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="限次" prop="LimitTimes">
            <el-input-number v-model="addForm.LimitTimes" :min="1" :max="99" />
          </el-form-item>
          <el-form-item label="每次就餐金额(元)" prop="FixedAmount">
            <el-input v-model="addForm.FixedAmount" type="number" min="0" />
          </el-form-item>

          <el-form-item label="请假可退餐">
            <el-switch v-model="addForm.AllowLeaveMealRefund" active-text="是" inactive-text="否"></el-switch>
            <div class="field-desc">开启后请假时可勾选本餐退餐，仅做登记，不联动订餐退订</div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.Remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getDinnerTimeListPage, removeDinnerTime, editDinnerTime, addDinnerTime } from '../../api/modules/consumption';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        DinnerName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        TimeArr: [
          { required: true, message: '请选择就餐时间段', trigger: 'change' }
        ],
        LimitTimes: [
          { required: true, message: '请输入限次', trigger: 'blur' }
        ],
        FixedAmount: [
          { required: true, message: '请输入固定金额', trigger: 'blur' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        DinnerName: "",
        StartTime: "",
        EndTime: "",
        Remarks: "",
        DepartmentId: 0,
        TimeArr: [],
        LimitTimes: 1,      // 新增
        FixedAmount: 0,     // 新增
        AllowLeaveMealRefund: false,
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        DinnerName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        TimeArr: [
          { required: true, message: '请选择就餐时间段', trigger: 'change' }
        ],
        LimitTimes: [
          { required: true, message: '请输入限次', trigger: 'blur' }
        ],
        FixedAmount: [
          { required: true, message: '请输入固定金额', trigger: 'blur' }
        ],
      },
      //新增界面数据
      addForm: {
        DinnerName: "",
        StartTime: "",
        EndTime: "",
        Remarks: "",
        DepartmentId: 0,
        TimeArr: [],
        LimitTimes: 1,      // 新增
        FixedAmount: 0,     // 新增
        AllowLeaveMealRefund: false,
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false
    };
  },
  methods: {
    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getDinnerTimeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeDinnerTime(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    // 显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    // 显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.options = [];
      this.addForm = {
        DinnerName: "",
        StartTime: "",
        EndTime: "",
        Remarks: "",
        DepartmentId: this.DepartmentId,
        TimeArr: ["00:00:00", "23:59:59"],
        LimitTimes: 1,      // 新增
        FixedAmount: 0,     // 新增
        AllowLeaveMealRefund: false
      };
    },
    // 编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.StartTime = para.TimeArr[0] || ""
            para.EndTime = para.TimeArr[1] || ""
            editDinnerTime(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    // 新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.StartTime = para.TimeArr[0] || ""
            para.EndTime = para.TimeArr[1] || ""
            addDinnerTime(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.field-desc {
  margin-top: 4px;
  font-size: 12px;
  line-height: 18px;
  color: #5b6b82;
}
</style>
